import { TextChip } from "../../../components/ui/TextChip";
import { ProcessInformation } from '../../../types/processDashboard';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import { colorSchemas, processStatusColors } from "../../../utilities/chipColorSchemas";

interface Props {
    processInfo: ProcessInformation;
    isCurrentProcess?: boolean;
}

const processConfirmationTitles = {
    "IVR": "Confirmacion por llamada telefónica",
    "Mensaje": "Confirmacion por mensaje"
}

export function ProcesoConfirmacionInfo({ processInfo, isCurrentProcess }: Props) {

    const processTitle = processInfo.canal == "IVR"
        ? processConfirmationTitles.IVR
        : processConfirmationTitles.Mensaje;

    const processIcon = processInfo.canal == "IVR"
        ? <CallRoundedIcon sx={{ width: 22, height: 22 }}/>
        : <MessageRoundedIcon sx={{ width: 22, height: 22 }}/>;

    return (
        <div className="bg-slate-50 px-4 py-2 border border-t-0 border-slate-200 rounded-md mt-2">
            <div className="flex items-center my-2 gap-2">
                {processIcon}
                <p className="text-md font-semibold m-0">{processTitle}</p>

                {processInfo?.procesoIniciado
                ?
                <TextChip
                    size="sm"
                    text={"Proceso iniciado"}
                    borderColor={colorSchemas.verde.borderColor}
                    bgColor={colorSchemas.verde.bgColor}
                    textColor={colorSchemas.verde.textColor}/>
                :
                <TextChip
                    size="sm"
                    text={"No iniciado"}
                    borderColor={processStatusColors["No Iniciado"].borderColor}
                    bgColor={processStatusColors["No Iniciado"].bgColor}
                    textColor={processStatusColors["No Iniciado"].textColor}/>
                }

                {isCurrentProcess && (
                <TextChip
                    size="sm"
                    text={"Proceso actual"}
                    borderColor={colorSchemas.azul.borderColor}
                    bgColor={colorSchemas.azul.bgColor}
                    textColor={colorSchemas.azul.textColor}/>
                )}

                {processInfo?.respuesta == "Fallo" && (
                <TextChip
                    size="sm"
                    text={"Fallo en el proceso"}
                    borderColor={processStatusColors["Fallo"].borderColor}
                    bgColor={processStatusColors["Fallo"].bgColor}
                    textColor={processStatusColors["Fallo"].textColor}/>
                )}
            </div>

            <div className="grid grid-cols-2">
                <div className="mb-3">
                    <p className="text-sm font-semibold m-0">{processInfo.procesoIniciado ? "Fecha de envio" : "Fecha de envio programado"}</p>
                    <p className="text-sm font-semibold m-0 text-gray-600">{processInfo?.fechaEnvio}</p>
                </div>

                <div className="mb-3">
                    <p className="text-sm font-semibold m-0">Fecha de última respuesta</p>
                    <p className="text-sm font-semibold m-0 text-gray-600">{processInfo?.fechaUltimaActualizacion ?? "Sin respuesta recibida"}</p>
                </div>

                {processInfo?.respuesta && (
                <div className="mb-2 border-l-2 border-green-600 px-[6px]">
                    <p className="text-[15px] font-semibold m-0">Respuesta del paciente</p>
                    <p className="text-[15px] font-semibold m-0 text-gray-600">{processInfo?.respuesta}</p>
                </div>
                )}
            </div>
        </div>
    );
}
